import { Component, ElementRef, OnInit, inject, signal } from "@angular/core";
import { BookingsService } from '../../services/bookings.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Blog } from '../../models/blog';
import { Category } from '../../models/category';
import { FormControl } from '@angular/forms';
import { CategoryService } from '../../services/categories.service';
import { ConfirmationService, MessageService, SelectItem, PrimeTemplate } from "primeng/api";
import * as moment from 'moment';
import { TYPE_LIST } from '../../constants/constants';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { Location } from '@angular/common';
import { WorksService } from 'src/app/services/works.service';
import { Works } from 'src/app/models/works';
import { EmployeesService } from 'src/app/services/employees.service';
import { Employees } from 'src/app/models/employees';
import { Locations } from 'src/app/models/locations';
import { LocationsService } from 'src/app/services/locations.service';
import { Bookings } from 'src/app/models/bookings';
import { SumPipe } from '../../pipe/sum.pipe';
import { BillingsService } from 'src/app/services/billings.service';
import { Billings } from 'src/app/models/billings';
import { Contact } from 'src/app/models/contact';
import { CmspageService } from 'src/app/cmspage/cmspage.service';
import { Title } from '@angular/platform-browser';
import { SupportsService } from 'src/app/services/supports.service';
import { Supports } from 'src/app/models/supports';
import { Observable } from "rxjs";
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { Card } from 'primeng/card';
import { Tag } from 'primeng/tag';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { Ripple } from 'primeng/ripple';
import { Timeline } from 'primeng/timeline';
import { Toast } from 'primeng/toast';

import { TPipe } from "../../i18n/t.pipe";
import { PhoneInputComponent } from "../../components/phone-input/phone-input.component";
@Component({
    standalone: true,
    selector: "app-supports-form",
    templateUrl: "./supports-form.component.html",
    imports: [PhoneInputComponent, TPipe, TopNavComponent, Bind, ButtonDirective, Card, Tag, FormsModule, ReactiveFormsModule, InputText, Textarea, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, Timeline, PrimeTemplate, Toast]
})
export class SupportsFormComponent implements OnInit {
  private router = inject(Router);
  private cmspageService = inject(CmspageService);
  private titleService = inject(Title);
  protected route = inject(ActivatedRoute);
  private supportsService = inject(SupportsService);
  private fb = inject(UntypedFormBuilder);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);
  private _location = inject(Location);

  title = 'Support';
  model = new Contact();
  readonly submitted = signal(false);
  readonly error = signal({});
  readonly success = signal<any>(undefined);
  readonly id = signal<string>(undefined);
  readonly is_active = signal<string>(undefined);
  blogForm: UntypedFormGroup;
  readonly currentUser = signal<any>(undefined);
  contactForm: UntypedFormGroup;
  readonly uploadError = signal<string>(undefined);

  readonly support = signal<Supports>(undefined);
  supports: Observable<Supports[]>;
  readonly supportsList = signal<any>(undefined);
  readonly supportsCount = signal<Supports>(undefined);

  constructor() {
    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));
    const id = this.route.snapshot.paramMap.get("id");

  }

  ngOnInit() {
    this.titleService.setTitle(this.title);

    const userId = this.currentUser().user_id;

    const id = this.route.snapshot.paramMap.get("id");

    if (id) {
      this.supportsService.getId(id).subscribe((res) => {
        if (res.user_id == this.currentUser().user_id) {
          this.blogForm.patchValue({
            title: res.title,
            phone: res.phone,
            email: res.email,
            name: res.name,
            sender_id: res.sender_id,
            user_id: this.currentUser().user_id,
            ref_id: res.id,
            id: res.id,
            is_active: res.is_active,
            data: res.data
          });
          this.route.paramMap.subscribe((params) => {
            this.supportsService.getId(id)
              .subscribe(data => {
                this.support.set(data);
              }, error => console.log(error));
          });
          this.supportsService.find_tickets_support_id(id).subscribe(
            (data: Billings) => (this.supportsList.set(data)),
            (error) => (this.error.set(error))
          );

        }
        else {
          this.router.navigate(['/admin/rooms']);
        }
        this.id.set(res.id);
        this.is_active.set(res.is_active);

      });
    } else {

    }

    this.blogForm = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      phone: [""],
      message: ["", Validators.required],
      name: [this.currentUser().first_name + ' ' + this.currentUser().last_name],
      sender_id: [this.currentUser().user_id],
      email: [""],
      ref_id: [this.id()],
      user_id: [this.currentUser().user_id],
    });
  }

  onDelete(id: string, title: string) {

    this.confirmationService.confirm({
      message: 'Sei sicuro di volerlo cancellare = ' + id,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.supportsService.delete(id).subscribe(
          res => {
            console.log(res);
            this.ngOnInit();
            this.messageService.add({ key: 'myKey1', severity: 'warn', summary: 'Attenzione', detail: 'Cancellazione avvenuto con successo' });

          },
          error => this.error.set(error)
        );
      },
    });
  }

  onSubmit() {
    const formData = new FormData();

    formData.append("title", this.blogForm.get("title").value);
    formData.append("email", this.blogForm.get("email").value);
    formData.append("message", this.blogForm.get("message").value);
    formData.append("name", this.blogForm.get("name").value);
    formData.append("sender_id", this.blogForm.get("sender_id").value);

    formData.append("ref_id", this.blogForm.get("ref_id").value);
    formData.append("phone", this.blogForm.get("phone").value);
    formData.append('user_id', this.blogForm.get('user_id').value);
    const id = this.blogForm.get("id").value;

    if (id) {
      this.supportsService.create(formData).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.supportsService.find_tickets_support_id(id).subscribe(
              (data: Billings) => (this.supportsList.set(data)),
              (error) => (this.error.set(error))
            );
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Richiesta inviata con sucesso' });
            this.blogForm.get('message').reset();

          }
        },
        (error) => (this.error.set(error))
      );
    } else {
      formData.append("ref_id", '0');

      this.supportsService.create(formData).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Richiesta inviata con sucesso' });
            this.router.navigate(['/admin/support']);
            this.getSupportsCount();

          }
        },
        (error) => (this.error.set(error))
      );

    }
  }

  close() {
    const formData = new FormData();
    formData.set('is_active', '0');
    const id = this.blogForm.get("id").value;
      this.supportsService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'warn', summary: 'Informazioni', detail: 'Ticket chiuso con sucesso' });
            this.blogForm.get('message').reset();
            this.ngOnInit();
          }
        },
        (error) => (this.error.set(error))
      );
  }

  open() {
    const formData = new FormData();
    formData.set('is_active', '1');
    const id = this.blogForm.get("id").value;
      this.supportsService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'ticket aperto con sucesso' });
            this.blogForm.get('message').reset();
            this.ngOnInit();
          }
        },
        (error) => (this.error.set(error))
      );
  }

  onSubmit_old() {
    this.submitted.set(true);
    return this.cmspageService.contactForm(this.model).subscribe(
      data => this.success.set(data),
      error => this.error.set(error)
    );
    this.router.navigate(['/admin/support/']);

  }

  getSupportsCount() {
    this.supportsService.count().subscribe(data => {
      this.supportsCount.set(data);
      error => this.error.set(error)
    });
  }

  gotoHome() {
    this.router.navigate(['/']);
  }
}
